import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setStoredToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    setStoredToken(res.data.session_token);
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (name, email, password, referralCode) => {
    const res = await api.post("/auth/register", { name, email, password, referral_code: referralCode || null });
    setStoredToken(res.data.session_token);
    setUser(res.data.user);
    return res.data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setStoredToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, refresh: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
